var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403Mob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "285px",
    height: "136px",
    viewBox: "0 0 285 136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.8887972%",
    y1: "122.196689%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E4E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.15593807%",
    y1: "50%",
    x2: "93.4026202%",
    y2: "37.7801853%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.8887972%",
    y1: "122.196689%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.365515%",
    y1: "3.94981298%",
    x2: "82.0367661%",
    y2: "105.618498%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.426712%",
    y1: "18.7737542%",
    x2: "50%",
    y2: "95.0406461%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.884048%",
    y1: "64.0348136%",
    x2: "100%",
    y2: "64.0348136%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F2F2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-15.6%",
    width: "124.9%",
    height: "159.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 16,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.48 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.6983863%",
    y1: "0%",
    x2: "23.2742059%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.884048%",
    y1: "64.0348136%",
    x2: "100%",
    y2: "64.0348136%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tilting-Point-404",
    transform: "translate(-71.000000, -205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(84.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 5.382716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(43.947912, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.564765005,0.367927017 C0.564765005,0.367927017 0.659937388,5.2153913 0.564765005,7.72646735 C0.469592623,10.2375434 0,15.2689712 0,15.2689712 C0,15.2689712 1.40555853,15.1328613 2.82382503,14.7170807 C4.24209152,14.3013 5.64765005,13.6132996 5.64765005,13.6132996 L6.02416006,0.183963508 C6.02416006,0.183963508 4.51788945,0.323529802 3.20033503,0.367927017 C1.88278061,0.412324231 0.564765005,0.367927017 0.564765005,0.367927017 Z",
    id: "Path-5",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.376510004,15.0850077 C0.376510004,15.0850077 0.967692564,14.249698 1.50604001,13.2453726 C2.04438746,12.2410472 2.44731502,11.221774 2.44731502,11.221774 C2.44731502,11.221774 4.40951631,11.1815943 7.34194507,10.6698835 C10.2743738,10.1581727 12.9895951,9.38213893 12.9895951,9.38213893 C12.9895951,9.38213893 12.1029954,11.2499293 11.4835551,12.2335733 C10.8641149,13.2172173 9.97751509,14.1651901 9.97751509,14.1651901 C9.97751509,14.1651901 7.93160384,14.664196 5.45939505,14.9010442 C2.98718626,15.1378924 0.376510004,15.0850077 0.376510004,15.0850077 Z",
    id: "Path-7",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31778501,4.4151242 L2.63557003,0.551890525 C2.63557003,0.551890525 4.03033782,0.287653229 6.68305256,0.183963508 C9.33576731,0.0802737882 12.0483201,0.183963508 12.0483201,0.183963508 L10.3540251,3.86323368 C10.3540251,3.86323368 7.50399619,3.73538544 5.83590506,3.86323368 C4.16781392,3.99108191 1.31778501,4.4151242 1.31778501,4.4151242 Z",
    id: "Path-6",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40067006,5.88683227 C6.40067006,5.88683227 6.10151762,6.78851793 5.64765005,7.54250384 C5.19378249,8.29648975 4.51812004,9.01421191 4.51812004,9.01421191 C4.51812004,9.01421191 5.8299254,9.06041148 7.15369007,9.01421191 C8.47745473,8.96801234 9.78926009,8.8302484 9.78926009,8.8302484 C9.78926009,8.8302484 10.4937026,7.78728414 10.7305351,7.26655858 C10.9673676,6.74583302 11.2953001,5.51890525 11.2953001,5.51890525 C11.2953001,5.51890525 9.76778946,5.80353997 8.65973008,5.88683227 C7.5516707,5.97012456 6.40067006,5.88683227 6.40067006,5.88683227 Z",
    id: "Path-8",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(26.761578, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6489112,11.0881011 C14.0243697,14.1212191 10.7627145,15.3646535 7.70352704,15.3646535 C3.44898654,15.3646535 0,11.9869943 0,7.82044056 C0,3.65388679 3.44898654,0.276227592 7.70352704,0.276227592 C8.43447964,0.276227592 10.589009,0.0899585654 11.2590011,0.276227592 C8.88830506,1.03499456 5.7282637,3.50434183 5.7282637,6.07946833 C5.7282637,9.28450969 8.38133027,11.8827091 11.6540537,11.8827091 C12.7466179,11.8827091 13.7701221,11.5931429 14.6489112,11.0881011 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75300035,4.11072712 L6.51836904,0.193441358 C6.51836904,0.193441358 8.09857971,0 10.8639484,0 C13.6293171,0 16.3946858,0.628782671 16.3946858,0.628782671 L13.6293171,4.11072712 C13.6293171,4.11072712 10.6664221,3.6753858 8.69115872,3.6753858 C6.71589537,3.6753858 3.75300035,4.11072712 3.75300035,4.11072712 Z",
    id: "Path-6",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62392196,12.5199546 L9.8214483,7.49047925 C9.8214483,7.49047925 10.80908,7.29703789 13.5744487,7.49047925 C16.3398173,7.68392061 16.9323963,8.07080333 16.9323963,8.07080333 C16.9323963,8.07080333 17.6637342,9.38963469 17.920028,10.0589506 C18.1763218,10.7282665 18.7101333,12.7133959 18.7101333,12.7133959 C18.7101333,12.7133959 16.142291,11.9396305 14.1670277,11.9396305 C12.1917643,11.9396305 9.62392196,12.5199546 9.62392196,12.5199546 Z",
    id: "Path-6",
    fill: "url(#linearGradient-3)",
    transform: "translate(14.167028, 10.058951) rotate(-270.000000) translate(-14.167028, -10.058951) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7282637,9.7205265 L8.49363238,5.80324074 C8.49363238,5.80324074 10.0738431,5.60979938 12.8392117,5.60979938 L16.9872648,5.60979938 L14.2218961,9.47862654 C14.2218961,9.47862654 12.6416854,9.28518519 10.6664221,9.28518519 C8.69115872,9.28518519 5.7282637,9.7205265 5.7282637,9.7205265 Z",
    id: "Path-6",
    fill: "url(#linearGradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.209125792 C0,0.209125792 0.7443714,5.92874559 0.637022429,8.78328328 C0.529673457,11.637821 0.21234081,15.4753086 0.21234081,15.4753086 L3.39745295,15.4753086 C4.88383862,15.4753086 6.15788348,14.6388055 6.15788348,14.6388055 L6.15788348,0 C6.15788348,0 4.45891474,0.15865538 2.97277133,0.209125792 C1.48662793,0.259596205 0,0.209125792 0,0.209125792 Z",
    id: "Path-5",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.69872648,3.37699428 L4.67149781,0.0309815989 C4.67149781,0.0309815989 14.2268342,-0.209125792 14.6515159,3.79524586 C15.0761975,7.79961752 12.315767,8.3650317 10.6170405,8.99240908 C8.918314,9.61978645 1.48638567,9.61978645 1.48638567,9.61978645 L4.88383862,6.06464798 C4.88383862,6.06464798 8.49363238,6.30475537 8.918314,5.25912641 C11.0417221,2.54049111 1.69872648,3.37699428 1.69872648,3.37699428 Z",
    id: "Path-9",
    fill: "url(#linearGradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.820762, 0.000000)",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.78446122,2.47111656 L9.11056221,2.47111656 L11.8243467,2.09094479 L4.84604373,15.2068712 L2.32610099,15.3969571 L0,15.2068712 C0,15.2068712 2.7079265,10.8431768 3.87683498,8.64890798 C5.04574347,6.45463918 6.78446122,2.47111656 6.78446122,2.47111656 Z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45836023,12.3555828 C5.17179393,11.7559169 6.26486928,11.2444758 6.97830297,10.6448098 C7.62176152,10.1039604 8.52903697,8.93403681 8.52903697,8.93403681 L11.2428215,8.74395092 L14.9258147,7.98360736 L13.5689224,10.1695951 L12.2120302,11.5952393 C12.2120302,11.5952393 9.48585446,12.0336519 8.14135347,12.1654969 C6.79685247,12.2973419 5.69841589,12.23398 4.45836023,12.3555828 Z",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55982822,1.14051534 C7.55982822,1.14051534 8.91737322,5.98930579 9.88592921,8.36377914 C10.8544852,10.7382525 12.9873972,14.4465276 12.9873972,14.4465276 C12.9873972,14.4465276 15.2675855,14.5460729 16.2827069,14.4465276 C17.2978284,14.3469824 18.8026497,13.8762699 18.8026497,13.8762699 C18.8026497,13.8762699 15.8754355,9.56737201 14.9258147,7.2232638 C13.9761939,4.8791556 13.1812389,0 13.1812389,0 C13.1812389,0 11.5387423,0.392234603 10.6612962,0.570257669 C9.78385008,0.748280734 7.55982822,1.14051534 7.55982822,1.14051534 Z",
    id: "Path-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    filter: "url(#filter-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    fill: "url(#linearGradient-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.401473, 43.721107) rotate(-270.000000) translate(-43.401473, -43.721107) translate(-0.335994, 0.995799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.84858682 C5.24201133,9.44612822 9.79347166,8.84858682 18.4987798,7.74251347 C27.2040879,6.63644012 34.7257589,4.42429341 34.7257589,4.42429341 C42.5015246,14.8310835 46.7910313,24.3336138 56.5845029,37.606494 C65.808058,50.1069786 85.9649179,73.0008413 85.9649179,73.0008413 L62.0253205,81.8494281 C62.0253205,81.8494281 45.6386904,67.810459 30.4685785,49.7733009 C15.8982069,32.4492299 2.57533952,11.1474583 0,8.84858682 Z",
    id: "Path-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "58.7608299 0 62.0253205 85.1676482 85.9649179 73.0008413 87.0530814 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(58.095785, 15.635365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.16553374 C0,1.16553374 3.99844873,33.0430453 3.4218154,48.9524172 C2.84518207,64.8617891 1.14060513,86.249497 1.14060513,86.249497 L18.2496821,86.249497 C26.2339181,86.249497 33.0775489,81.587362 33.0775489,81.587362 L33.0775489,0 C33.0775489,0 23.9514065,0.884243867 15.9684719,1.16553374 C7.98553727,1.44682362 0,1.16553374 0,1.16553374 Z",
    id: "Path-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(85.666667, 10.247164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4544056,64.0777234 C70.3227515,80.9258861 53.9677514,87.8328328 38.6279902,87.8328328 C17.2943403,87.8328328 0,69.0708357 0,45.9267394 C0,22.7826431 17.2943403,4.020646 38.6279902,4.020646 C42.2932243,4.020646 53.0967352,2.98597117 56.4562934,4.020646 C44.5688526,8.23539437 28.7233774,21.9519607 28.7233774,36.2561025 C28.7233774,54.0592535 42.0267161,68.4915589 58.437216,68.4915589 C63.9156881,68.4915589 69.047871,66.8830962 73.4544056,64.0777234 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2230736,23.7551094 C17.3547277,6.90694677 33.7097278,0 49.049489,0 C70.3831389,0 87.6774792,18.7619971 87.6774792,41.9060934 C87.6774792,65.0501897 70.3831389,83.8121868 49.049489,83.8121868 C45.3842549,83.8121868 34.580744,84.8468617 31.2211858,83.8121868 C43.1086266,79.5974385 58.9541018,65.8808721 58.9541018,51.5767304 C58.9541018,33.7735793 45.6507631,19.3412739 29.2402632,19.3412739 C23.7617911,19.3412739 18.6296082,20.9497366 14.2230736,23.7551094 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(180.687739, 0.975920)",
    fill: "url(#linearGradient-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6951087,6.71367506 C42.6951087,6.71367506 51.2308438,38.4226707 50.6542105,56.3122173 C50.0775772,74.201764 40.5443211,102.840143 40.5443211,102.840143 C40.5443211,102.840143 52.2701306,102.840143 60.2543665,102.840143 C60.7168679,102.840143 70.0028362,97.5977313 70.0028362,97.5977313 C70.0028362,97.5977313 75.3105991,75.3370817 75.3105991,52.1886907 C75.3105991,29.0402998 70.2349995,5.40307207 70.2349995,5.40307207 C70.2349995,5.40307207 63.3900673,6.39737417 55.4071327,6.71367506 C47.4241981,7.02997594 42.6951087,6.71367506 42.6951087,6.71367506 Z",
    id: "Path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5639263,52.126093 C29.5639263,52.126093 30.5583768,74.0561881 29.8448045,85.7587496 C29.1312321,97.461311 21.4206737,124.530871 21.4206737,124.530871 C21.4206737,124.530871 26.546479,123.435744 32.5820257,122.656771 C38.6175723,121.877797 42.9708749,122.179503 42.9708749,122.179503 C42.9708749,122.179503 51.7525251,101.488773 52.8032426,86.5963971 C53.8539601,71.704021 54.1990199,66.8133054 54.1990199,66.8133054 L49.4572028,57.1211857 C49.4572028,57.1211857 42.6754171,55.0120749 40.4206468,54.5696958 C30.9455047,52.7107016 29.5639263,52.126093 29.5639263,52.126093 Z",
    id: "Path-5",
    transform: "translate(37.809847, 88.328482) scale(-1, -1) rotate(-94.000000) translate(-37.809847, -88.328482) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3832682,-15.2622885 C31.3832682,-15.2622885 32.3777186,6.66780667 31.6641463,18.3703681 C30.950574,30.0729296 20.5825321,56.5584242 20.5825321,56.5584242 C20.5825321,56.5584242 27.0190646,56.6828931 35.5184708,56.150408 C36.090596,56.1145646 48.6134676,54.6755528 48.6134676,54.6755528 C48.6134676,54.6755528 52.7633908,32.5063333 52.7633908,17.3636652 C52.7633908,2.22099708 56.4411026,-9.37299094 56.4411026,-9.37299094 C56.4411026,-9.37299094 54.7401295,-10.6537012 45.2649873,-12.5126954 C35.7898452,-14.3716896 31.3832682,-15.2622885 31.3832682,-15.2622885 Z",
    id: "Path-5",
    transform: "translate(38.511817, 20.654384) scale(-1, 1) rotate(-94.000000) translate(-38.511817, -20.654384) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(35.589064, 53.596993) rotate(-270.000000) translate(-35.589064, -53.596993) translate(27.790911, 38.121685)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "0.254224808 0 2.01259298 30.7414915 15.4934157 21.4653321 15.4934157 0"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403Mob);
export default __webpack_public_path__ + "static/media/403-mob.2d51b139.svg";
export { ForwardRef as ReactComponent };